import { UserWorkInfoActions } from "../actions/user-work-info";
import { UserWorkInfo } from "../dto/user-work-info";
import { addToLoadingQueue, removeFromLoadingQueue } from "../utils";

export interface UserWorkInfoState {
  loadingQueue: string[];
  userWorkInfo: UserWorkInfo | null;
}

const defaultState: UserWorkInfoState = {
  loadingQueue: [],
  userWorkInfo: null,
};

export default function UserWorkInfoReducer(
  state: UserWorkInfoState = defaultState,
  action: any
): UserWorkInfoState {
  switch (action.type) {
    case UserWorkInfoActions.REQUEST_GET_USER_WORK_INFO:
      return {
        ...state,
        loadingQueue: addToLoadingQueue(state.loadingQueue, action.type),
      };
    case `${UserWorkInfoActions.REQUEST_GET_USER_WORK_INFO}_SUCCESS`:
      return {
        ...state,
        loadingQueue: removeFromLoadingQueue(state.loadingQueue, action.type),
        userWorkInfo: action?.payload,
      };
    case `${UserWorkInfoActions.REQUEST_GET_USER_WORK_INFO}_FAILURE`:
      return {
        ...state,
        loadingQueue: removeFromLoadingQueue(state.loadingQueue, action.type),
        userWorkInfo: null,
      };
    default:
      return state;
  }
}
